import { StandardEvents } from '@shopify/events';

/**
 * Product-page add-to-cart navigation for themes configured with cart_type: page.
 * It only follows successful native product adds; quantity updates and express
 * checkout are intentionally left alone.
 */
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add' || event.context !== 'product' || !event.promise) return;

  event.promise.then((result) => {
    if (result?.detail?.didError || result?.userErrors?.length) return;
    window.location.assign(Theme.routes.cart_url);
  }).catch(() => {
    // The native product form owns error messaging; navigation must stay put.
  });
});
